import './i18n'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { MsalProvider } from './lib/auth/MsalProvider'
import { ThemeProvider } from './lib/theme/ThemeProvider'
import App from './App'
import './index.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <MsalProvider>
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </MsalProvider>
  </StrictMode>,
)
